import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MockFeedbackService {
    private feedbackStore: any[] = [];

    async getUserFeedback(userId: string) {
        return this.feedbackStore
            .sort((a, b) => b.createdAt - a.createdAt);
    }

    async getAllFeedback() {
        return this.feedbackStore.sort((a, b) => b.createdAt - a.createdAt);
    }

    async submitFeedback(data: any) {
        const newFeedback = {
            ...data,
            createdAt: {
                toMillis: () => Date.now(),
                toDate: () => new Date()
            },
            id: 'mock-' + Date.now()
        };
        this.feedbackStore.push(newFeedback);
        return newFeedback;
    }
}
